<template>
    <b-card no-body :style="{ color: color , backgroundColor: backgroundColor}" class="tile mb-4">
      <b-card-header :style="{ backgroundColor: headerBackgroundColor }">
        {{title}}
      </b-card-header>
      <b-card-body >
        <h1 class="mb-0 hyper-link" @click="bodyClick(title,number)">{{number}}</h1>
      </b-card-body>
    </b-card>
</template>

<script>

export default {
  name: 'tile',
  props: {
    number: {
        type: Number,
        default: 0
    },    
    title: {
        type: String,
        default: ""
    },
    cardClass: {
        type: String,
        default: ""
    },
    cardClass: {
        type: String,
        default: ""
    },
    color: {
        type: String,
        default: "black"
    },
    backgroundColor: {
        type: String,
        default: "white"
    },
    headerBackgroundColor: {
        type: String,
        default: "white"
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    bodyClick(status,number){
      if(number != 0){
        this.$emit('tile-click',status);
      }
    }
  }
}
</script>